/**
 * useBookingStats — fetches the week-scoped booking KPI stats once on mount.
 * Independent of the list's filter/sort/pagination state. Returns null while
 * loading or on error (the KPI strip renders em-dash placeholders then).
 *
 * `refreshKey` is an opaque value (e.g. a counter bumped by the caller) that
 * re-triggers the fetch when it changes — used to refresh the strip after a
 * CSR-created booking (BON-142) without introducing a separate refetch API.
 */
import { useEffect, useState } from 'react';

import { fetchBookingStats, type BookingStats } from '../../api/bookingsList';

export function useBookingStats(refreshKey: unknown = 0): BookingStats | null {
  const [stats, setStats] = useState<BookingStats | null>(null);
  useEffect(() => {
    fetchBookingStats()
      .then(setStats)
      .catch(() => setStats(null));
  }, [refreshKey]);
  return stats;
}
